<template>
  <section>
    <ActionsButtons
      :actions="a"
      class="hidden-sm-and-down"
    />

    <ActionsDropdown
      :actions="a"
      class="hidden-md-and-up"
    />
  </section>
</template>

<script>
import ActionsButtons from '@/components/Navigation/Header/Actions/Buttons'
import ActionsDropdown from '@/components/Navigation/Header/Actions/Dropdown'

export default {
  components: {
    ActionsButtons,
    ActionsDropdown
  },
  props: {
    actions: {
      type: Array,
      required: true
    }
  },
  computed: {
    a () {
      let actions = this.actions

      if (!Array.isArray(actions[0])) {
        actions = [ actions ]
      }

      return actions
    }
  }
}
</script>
